<template>
  <div class="management">
    <v-container>
      <div>
				<h4 class="my-5">{{ $t("manage.header") }}</h4>
      </div>
      <v-row>
        <v-col sm="4">
          <v-card class="full-height" color="#fafafa" max-width="250" min-width="150px" @click="goTo('list')">            
            <v-responsive :aspect-ratio="5/3">
              <v-card-title class="justify-center">
                <v-icon x-large>mdi-account-cog</v-icon>
              </v-card-title>
              <v-card-title class="justify-center">              
                {{ $t("manage.index.by_admin") }}
              </v-card-title>
            </v-responsive>
          </v-card>
        </v-col>
        <v-col sm="4">
          <v-card class="full-height" color="#fafafa" max-width="250" min-width="150px" @click="goTo('school')">
            <v-responsive :aspect-ratio="5/3">
              <v-card-title class="justify-center">
                <v-icon x-large>mdi-school</v-icon>
              </v-card-title>
              <v-card-title class="justify-center">              
                {{ $t("manage.index.by_school") }}
              </v-card-title>
            </v-responsive>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

export default {
  name: "management",
  data: function () {
    return {
      name: "",
      role: null,
      drawer: true,
      mini: true,
    };
  },
  mounted: function () {
    this.name = this.$route.params.experiment_name;
    var self = this;
  },
  methods: {    
    goTo: function (name) {
      var self = this;
      if(self.$route.path != name){
        self.$router.push("/management/" + name);
      }
    },
  },
  destroyed(){
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>